import { render, staticRenderFns } from "./AlertLayout.vue?vue&type=template&id=8760ea96&scoped=true"
import script from "./AlertLayout.vue?vue&type=script&lang=ts"
export * from "./AlertLayout.vue?vue&type=script&lang=ts"
import style0 from "./AlertLayout.vue?vue&type=style&index=0&id=8760ea96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8760ea96",
  null
  
)

export default component.exports